import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { Env } from '@/libs/env';

// 扩展 dayjs 插件
dayjs.extend(utc);
dayjs.extend(timezone);

// 将秒转为日期+时分秒
export const formatSecondToDate = (second: number, format = 'DD/MM/YYYY HH:mm:ss') => {
  if (second) {
    const date = new Date(second * 1000);
    return dayjs(date).format(format);
  } else {
    return '';
  }
};

/**
 * 时间格式化函数
 * 根据 Env.REGION 判断地区，将北京时间转换为对应时区的时间
 */
export const formatTime = (timestamp: number, format: string = 'DD/MM/YYYY HH:mm') => {
  // 获取当前地区配置
  const region = Env.REGION;
  console.log('region', region);
  // 根据地区确定时区
  let targetTimezone: string;
  switch (region) {
    case 'india':
      targetTimezone = 'Asia/Kolkata'; // 印度标准时间 (IST) UTC+5:30
      break;
    case 'brazil':
      targetTimezone = 'America/Sao_Paulo'; // 巴西标准时间 (BRT) UTC-3
      break;
    case 'global':
    default:
      targetTimezone = 'Asia/Shanghai'; // 北京时间 (CST) UTC+8
      break;
  }

  // 将时间戳转换为目标时区的时间
  return dayjs(timestamp).tz(targetTimezone).format(format);
};

/**
 * 格式化倒计时时间（纯 JavaScript 实现，避免时区问题）
 * @param totalSeconds 总秒数
 * @param options 格式化选项
 * @param options.includeDaysSpace 天数后是否包含空格，默认 false (格式: "1d" vs "1 d")
 * @returns 格式化后的时间字符串，如 "2d 10:30:45" 或 "10:30:45"
 */
export const formatCountdown = (
  totalSeconds: number,
  options?: { includeDaysSpace?: boolean; }
): string => {
  const days = Math.floor(totalSeconds / (24 * 3600));
  const remainingAfterDays = totalSeconds % (24 * 3600);
  const hours = Math.floor(remainingAfterDays / 3600);
  const minutes = Math.floor((remainingAfterDays % 3600) / 60);
  const seconds = remainingAfterDays % 60;
  const pad = (n: number) => String(n).padStart(2, "0");

  if (totalSeconds >= 24 * 3600) {
    const daysSeparator = options?.includeDaysSpace ? " d " : "d ";
    return `${days}${daysSeparator}${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
};